import TextAndImage from "@/components/TextAndImage.vue";
import { heroTextInit } from "./HeroText";
import { mediaInit } from "./Media";
export const textAndImageInit = {
    component: TextAndImage,
    name: "Text And Image",
    inputs: [
        {
            name: "mediaProps",
            friendlyName: "Media Properties",
            type: "object",
            subFields: [
                ...mediaInit.inputs,
                {
                    name: "sort",
                    friendlyName: "Sort",
                    type: "number",
                    defaultValue: 0
                }
            ]
        },
        {
            name: "heroTextProps",
            friendlyName: "Hero Text Properties",
            type: "object",
            subFields: [
                ...heroTextInit.inputs,
                {
                    name: "sort",
                    friendlyName: "Sort",
                    type: "number",
                    defaultValue: 0
                }
            ]
        }
    ]
};
